import { Field, Form as UnstyledForm, Formik } from 'formik'
import styled from 'styled-components'
import SearchIcon from '@mui/icons-material/Search'

import navigate from '../core/navigate'
import React, { useState, useEffect } from 'react'

const FormLabel = styled.label`
  width: 1px;
  height: 1px;
  margin: -1px;
  display: inline-block;
  overflow: hidden;
`

const FormInput = styled.input`
  margin: 0;
  padding: 4px 8px;
  font-size: 14px;
  height: 32px;
  top: 2px;
  vertical-align: middle;
  color: #555555;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  text-align: left;

  ${props => props.theme.breakpoints.up('md')} {
    max-width: 120px;
  }
  ${props => props.theme.breakpoints.down('md')} {
    flex-grow: 1;
  }
`

const Form = styled(UnstyledForm)`
  ${props => props.theme.breakpoints.down('md')} {
    display: flex;
    flex-grow: 1;
    margin: 0 4px;
  }
`

const FormButton = styled.button`
  margin: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 5px;
  background-color: #68504c;
  color: white;
  border: none;
  transition: all 0.3s;
  vertical-align: middle;
  cursor: pointer;
  line-height: 0.5;

  :hover {
    background-color: #361611;
  }
`

const handleTerm = () => {
  const pathname = window.location.pathname
  const uriTerm = pathname.includes('/search/') ? decodeURI(pathname.substring(8)) : ''
  return (uriTerm != '*' && uriTerm != 'recommendations') ? uriTerm : ''
}

export default () => {
  const [term, setTerm] = useState(handleTerm())

  useEffect(() => {
    window.addEventListener('route', () => {
      setTerm(handleTerm())
    })
  }, [])

  return (
    <Formik
      enableReinitialize
      initialValues={{ searchTerm: term }}
      onSubmit={values => {
        values.searchTerm === ''
          ? alert('Please enter a search query')
          : navigate(`/search/${values.searchTerm}`)
      }}>
      <Form style={{minWidth: '151px'}}>
        <FormLabel htmlFor='searchTerm'>Search Items (required)</FormLabel>
        <Field id='searchTerm' name='searchTerm' placeholder='Search Items' as={FormInput} />
        <FormButton id='searchSubmit' type='submit'>
          {/* <span className='bi bi-play-fill'></span> */}
          <SearchIcon sx={{ fontSize: '22px' }} />
        </FormButton>
      </Form>
    </Formik>
  )
}
